export default __webpack_public_path__ + "static/realWorldImage1-46b64c28444b39e613f56b8036d9fce8.png";